import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';
import { LoginProvider } from 'providers/login/login';
import { TranslateService } from '@ngx-translate/core';
import { ImageResizeProvider } from 'providers/image-processor/image-resize';
import { MessageService, PopupMessage } from 'rb-core-library';
import { GetServiceUrl } from 'psapp-config';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

    user: any;
    rankingPositions: any;
    compaigns: any;
    isLoading: boolean = true;

    selectedCampaignId: any = null;

    profileData = {
        photo: null
    }
    profileImageSrc:string;

    @ViewChild("captureImageInput") captureImageInput;
    @ViewChild("uploadImageInput") uploadImageInput;

    constructor(
        private router: Router,
        private loginProvider: LoginProvider,
        private appService: AppService,
        private remoteServicesProvider: RemoteServicesProvider,
        private domainStorageProvider: DomainStorageProvider,
        public translationProvider: TranslationProvider,
        public translateService: TranslateService,
        private imageResizeProvider: ImageResizeProvider,
        public messageService: MessageService
    ) {
        this.showHideMenu(false);
        this.messageService.popupMessage = null;
    }

    ngOnInit() {
        this.user = this.domainStorageProvider.rootStore.loginProvider;

        this.domainStorageProvider.rootStore.selectedGroupId.subscribe(async campaignId => {
            if (campaignId) {
                this.selectedCampaignId = campaignId;
                this.rankingPositions = await this.domainStorageProvider.rootStore.getRankingPositions(campaignId);
            }
        });
        this.compaigns = this.domainStorageProvider.rootStore.userGroups;
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    back() {
        this.router.navigate(["/"]);
    }

    logout() {
        this.loginProvider.logout();
        this.router.navigate(["/login"]);
    }

    campaignClick(campaignName:string, campaignId){
        this.router.navigate(["/ranking", campaignName.trim(), campaignId]);
    }

    async fileChangeEvent(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            this.profileData.photo = null;
            await this.imageResizeProvider.resizeImage(fileInput.target.files[0], 800, 800).then(image => {
                this.profileData.photo = image;
                this.submitProfile();
            }, err => {
                let popupMessage: PopupMessage = {
                    type: 'danger',
                    text: this.translateService.instant("ProfilePage.ErrorUploading"),
                    timeout: 3000
                };
                this.messageService.addMessage(popupMessage);
            });
        }
    }

    async submitProfile() {
        this.isLoading = true;

        let statusCode: string = null;
        let sendSpotProcess = await this.remoteServicesProvider
            .updateProfile(this.profileData, this.loginProvider.token)
            .catch(err => {
                statusCode = err.status;
            });
        this.isLoading = false;

        let popupMessage: PopupMessage;
        if (sendSpotProcess) {
            popupMessage = {
                type: 'success',
                text: this.translateService.instant("ProfilePage.SuccessUploading"),
                timeout: 3000
            };
        }
        else {
            popupMessage = {
                type: 'danger',
                text: this.translateService.instant("ProfilePage.ErrorUploading"),
                timeout: 3000
            };
        }

        this.messageService.addMessage(popupMessage);
    }
}
